import { BasicEnumerable } from "../BasicEnumerable.js";
export const ofType = (source, type) => {
    const typeCheck = typeof type === "string" ?
        ((x) => typeof x === type) :
        ((x) => x instanceof type);
    function* iterator() {
        for (const item of source) {
            if (typeCheck(item)) {
                yield item;
            }
        }
    }
    return new BasicEnumerable(iterator);
};
